/**
 * US phone-number helpers. We store digits only (e.g. "1234567890") and format
 * for display/entry as "(123) 456-7890".
 *
 * - `phoneDigits` strips a value to at most 10 digits — used to normalize what
 *   gets stored (works whether the input arrives raw, masked, or as legacy
 *   already-formatted data).
 * - `formatPhone` renders the mask progressively as the user types, so the
 *   field reads naturally at every length.
 */
export const phoneDigits = (v) =>
  String(v ?? "").replace(/\D/g, "").slice(0, 10);

export const formatPhone = (v) => {
  const d = phoneDigits(v);
  if (d.length === 0) return "";
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};
